<app-header></app-header>
<!-- <app-banner-enquiry-form></app-banner-enquiry-form> -->
<app-banner-enquiry-form [backgroundImageId]="'6'"[loanTypeId]="8"  serviceName="health insurance planning"></app-banner-enquiry-form>>

<!-- Hero Section with Get In Touch Form -->
<!-- <section class="form-section">
 
  <div class="row d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="col-md-7">
        <div class="card transparent-card">
            <h1>We help you to Achieve your Financial Goals</h1>
            <a href="/appointment" class="btn btn-orange small-button ">Schedule a Meeting</a>
        </div>
    </div>


    <div class="col-md-5">
      <div class="form-container">
        <h2>GET IN TOUCH</h2>
        <h3 class="slogan">Your journey to financial freedom starts here!</h3>
        <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">
          <input type="text" formControlName="full_name" placeholder="Enter your Name" required>
          <input type="email" formControlName="email" placeholder="Enter your Email" required>
          <input type="tel" formControlName="phone" placeholder="Enter Phone Number" required>
          <input type="text" formControlName="enq_detail_msg" placeholder="Enter your Message" required>
          <button type="submit" [disabled]="!enquiryForm.valid">Submit</button>
        </form>
      </div>
    </div>
</div>
    

  
</section> -->
    

  
  <!-- <div class="form-container">

  
   
  </div> -->


  <!-- <div class="row">
    <div class="col-md-7">
      <h1 style="color: whitesmoke;">We help you to Achieve your Financial Goals</h1>
  <button class="schedule-button">Schedule a Meeting</button>
    </div>
    <div class="col-md-5">

      <h2>GET IN TOUCH</h2>
      <h3>Your journey to financial freedom starts here!</h3>
      <form>
        <input type="text" placeholder="Enter your Name" required>
        <input type="email" placeholder="Enter your Email" required>
        <input type="tel" placeholder="Enter Phone Number" required>
        <input type="text" placeholder="Enter your Message" required>
        <button type="submit">Submit</button>
      </form>
    </div>
  </div> -->
<!-- </section> -->


<div class="plan-section">
  <h2 class="plan-title">Health Insurance</h2>
  <p class="plan-description">
    Health insurance plays a crucial role in India's financial planning. It provides a safety net for individuals and families against unforeseen medical expenses, which can otherwise severely impact one's economic stability. Here's how health insurance helps in financial planning:</p>

  <h3 class="important-heading">
    Why is Health Insurance Important?
  </h3>
  <div class="underline"></div>




  <section class="service-section">
    <div class="content">
      <h2>Introduction</h2>
      <p>
        Health insurance plays a crucial role in financial planning in India. It provides a safety net for individuals and families against unforeseen medical expenses, which can otherwise severely impact one's financial stability. Here's how health insurance helps in financial planning:
        Protection Against Medical Emergencies: Health insurance provides financial protection against high medical expenses due to unexpected illnesses or accidents. It covers hospitalization costs, including room charges, doctor's fees, diagnostic tests, and medication, reducing the financial burden on the insured individual.
            </p>
    </div>
    <img src="assets/Services/fplanning.svg" alt="Financial Planning Introduction">
  </section>



<!-- Protection Against Medical Emergencies Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Protection Against Medical Emergencies</h2>
    <p>
      Health insurance provides financial protection against high medical expenses due to unexpected illnesses or accidents. It covers hospitalization costs, including room charges, doctor's fees, diagnostic tests, and medication, reducing the insured individual's financial burden.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/health insurance/humanitarian_5.jpg" alt="Financial Planning Introduction">
  </div>
</section>


<!-- Safeguarding Savings Section -->
<section class="service-section">
  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/18961661_healthinsurance_1.jpg" alt="Understanding Financial Situation">
  </div>

  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Safeguarding Savings:</h2>
    <p>
      Without health insurance, medical expenses can quickly deplete savings and investments. Health insurance ensures that savings are protected and can continue to grow, providing financial security for future needs.
    </p>
  </div>
</section>


<!-- Tax Benefits Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Tax Benefits:</h2>
    <p>
      Premiums paid towards health insurance policies are eligible for tax deductions under Section 80D of the Income Tax Act, providing additional savings.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/health insurance/online-tax-filing-concept-businessman-filling-tax-form-documents-online-vector-illustration.png" alt="Setting Financial Goals">
  </div>
</section>

  <section class="service-section">
    <img src="assets\health insurance\29361140_anesthesia_2.jpg" alt="Developing a Financial Plan">
    <div class="content">
      <h2>Access to Quality Healthcare</h2>
      <p>
        Health insurance enables access to quality healthcare facilities and services without worrying about the cost. This ensures timely medical treatment and better health outcomes.
    </p>
    </div>
  </section>

<!-- Family Coverage Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Family Coverage:</h2>
    <p>
      Family health insurance plans provide coverage for the entire family under a single policy. This simplifies the process of managing health insurance and ensures comprehensive coverage for all family members.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/health insurance/22182019_baby_2.jpg" alt="Monitoring and Adjusting">
  </div>
</section>


  
  <section class="service-section">

    <img src="assets\health insurance\136861660_add8a55a-de77-49e8-be19-4129cda1d0a9.jpg" alt="Monitoring and Adjusting">
    <div class="content">
      <h2>Critical Illness Coverage</h2>
      <p>
        Many health insurance plans offer coverage for critical illnesses like cancer, heart attack, and stroke. This coverage provides a lump sum payment upon diagnosis, which can be used to cover treatment costs or other financial needs. </p>
      </div>
    
  </section>
 <!-- Preventive Care Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Preventive Care</h2>
    <p>
      Some health insurance plans include coverage for preventive services like health check-ups, vaccinations, and wellness programs. This encourages individuals to prioritize preventive healthcare, reducing the risk of developing severe health conditions.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/health insurance/29361305_humanitarian_1.jpg" alt="Preventive Care Services">
  </div>
</section>


  <section class="service-section">
    <img src="assets\health insurance\19743030_stress_11.jpg" alt="Monitoring and Adjusting">
    <div class="content">
      <h2>Peace of Mind</h2>
      <p>
        Health insurance provides peace of mind, knowing that one's health and financial well-being are protected. This allows individuals to focus on other aspects of their lives without worrying about the economic implications of a medical emergency.   </p>
      </div>
   
  </section>

</div>


<section class="contact-us-section">
  <div class="contact-content">
    <h2>Contact Us  Today!</h2>
    <p class="slogan">Your journey to financial freedom starts here!</p>
  </div>

  <div class="contact-form-container"> 
    <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" class="contact-form">
      <h2>Submit Your Enquiry</h2>
      <input formControlName="full_name" type="text" placeholder="Your Name" required>
      <input formControlName="email" type="email" placeholder="Your Email" required>
      <input formControlName="phone" type="tel" placeholder="Your Phone Number" required>
      <input type="datetime-local" formControlName="appointment_date" id="appointmentDate" required>
      <textarea formControlName="enq_detail_msg" placeholder="Your Message" required></textarea>
      <button type="submit" [disabled]="enquiryForm.invalid">Send Message</button>
    </form>
  
    <!-- Standard message after submission -->

  <!-- Thank you message with animated smiley -->
  <div *ngIf="isEnquirySubmitted" class="thank-you-message animated">
    <h3>
      Thank you for your enquiry! We will get back to you shortly! 
      <span class="smiley">😊</span>
    </h3>
  </div>
  </div>
  
</section>



<app-footer></app-footer>
